export default "__VITE_ASSET__BhPPJczL__"